<!-- 产品中心 -->
<template>
    <div>
      <!-- <div class="header_img"></div> -->
      
       <sub-banner id="id_about">
        <img src="../../assets/images/product/product.png"/>
      </sub-banner>
      <div class="content_product">
         <div class="content_title">
             <span>{{$t('product.type')}}</span>
         </div>
         <div class="type_list">
             <div class="list_info">
                 <div class="list_item_product" :class="$store.state.lang=='en-US'?'list_item_product_special':''">
                     <div class="item_icon">
                         <img src="../../assets/images/product/youkeyi.png" />
                     </div>
                     <div class="item_content">
                         <div class="item_type_name">{{$t('product.type_title_1')}}</div>
                         <div class="item_type_descript">{{$t('product.type_content_1')}}</div>
                     </div>
                 </div>
                 <div class="list_item_product" :class="$store.state.lang=='en-US'?'list_item_product_special':''">
                     <div class="item_icon">
                         <img src="../../assets/images/product/shangcheng.png" />
                     </div>
                     <div class="item_content">
                         <div class="item_type_name">{{$t('product.type_title_2')}}</div>
                         <div class="item_type_descript">{{$t('product.type_content_2')}}</div>
                     </div>
                 </div>
                 <div class="list_item_product" :class="$store.state.lang=='en-US'?'list_item_product_special':''">
                     <div class="item_icon">
                         <img src="../../assets/images/product/diannao.png" />
                     </div>
                     <div class="item_content">
                         <div class="item_type_name">{{$t('product.type_title_3')}}</div>
                         <div class="item_type_descript">{{$t('product.type_content_3')}}</div>
                     </div>
                 </div>
                 <div class="list_item_product" :class="$store.state.lang=='en-US'?'list_item_product_special':''">
                     <div class="item_icon">
                         <img src="../../assets/images/product/shouji.png" />
                     </div>
                     <div class="item_content">
                         <div class="item_type_name">{{$t('product.type_title_4')}}</div>
                         <div class="item_type_descript">{{$t('product.type_content_4')}}</div>
                     </div>
                 </div>
                 <div class="list_item_product" :class="$store.state.lang=='en-US'?'list_item_product_special':''">
                     <div class="item_icon">
                         <img src="../../assets/images/product/weixin.png" />
                     </div>
                     <div class="item_content">
                         <div class="item_type_name">{{$t('product.type_title_5')}}</div>
                         <div class="item_type_descript">{{$t('product.type_content_5')}}</div>
                     </div>
                 </div>
                 <div class="list_item_product" :class="$store.state.lang=='en-US'?'list_item_product_special':''">
                     <div class="item_icon">
                         <img src="../../assets/images/product/xiaochengxu.png" />
                     </div>
                     <div class="item_content">
                         <div class="item_type_name">{{$t('product.type_title_6')}}</div>
                         <div class="item_type_descript">{{$t('product.type_content_6')}}</div>
                     </div>
                 </div>
             </div>
         </div>

         <div class="buttom_group">
             <div class="register_info" @click="register">{{$t('product.register')}}</div>
             <div class="learn_more" @click="learMore">{{$t('product.learMore')}}</div>
         </div>
      </div>
      <div class="pc_c_info">
        <div class="pc_content">
            <div class="pc_title"><span>{{$t('product.mall_title')}}</span></div>
            <div class="pc_info_content">
                <div class="image_pc">
                    <img src="../../assets/images/product/pc_product.png" />
                </div>
                <div class="pc_descript">
                    <div class="pc_item">
                        <div class="item_pc_title">{{$t('product.mall_content_title_1')}}</div>
                        <div class="item_pc_content">{{$t('product.mall_content_descript_1')}}</div>
                    </div>
                    <div class="pc_item">
                        <div class="item_pc_title">{{$t('product.mall_content_title_2')}}</div>
                        <div class="item_pc_content">{{$t('product.mall_content_descript_2')}}</div>
                    </div>
                    <div class="pc_item">
                        <div class="item_pc_title">{{$t('product.mall_content_title_3')}}</div>
                        <div class="item_pc_content">{{$t('product.mall_content_descript_3')}}</div>
                    </div>
                    <div class="pc_item">
                        <div class="item_pc_title">{{$t('product.mall_content_title_4')}}</div>
                        <div class="item_pc_content">{{$t('product.mall_content_descript_4')}}</div>
                    </div>
                </div>
            </div>
            <div class="buttom_group">
             <div class="register_info" @click="register">{{$t('product.register')}}</div>
             <div class="learn_more" @click="learMore">{{$t('product.learMore')}}</div>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
import { concatMeta } from '@/config/metaJson.js'

import SubBanner from "@/components/sub-banner";
export default {
  name: 'concat',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner},
  data () {
    return {
      pageTitle: '广州市优科易网络科技有限公司-产品中心',
      metaName:'广州市优科易网络科技有限公司-产品中心',
      metaContent:'广州市优科易网络科技有限公司-产品中心',
      keyword:'广州市优科易网络科技有限公司,优科易，网络科技,优科易网络科技',
      description:'广州市优科易网络科技有限公司' ,   
      
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou youkeyi Network Technology Co., Ltd',
        'zh-TCC': '廣州市優科易網絡科技有限公司',
        'zh-CN': '广州市优科易网络科技有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  methods: {
      register(){
       this.$router.push({
        path: '/about'
      })
     },
     learMore(){
       
       this.$router.push({
        path: '/cases'
      })
     }
  },
  created () {

  },
  mounted () {
  },
}
</script>
<style lang='scss' scoped>
.header_img{
  width: 100%;
  height: 300px;
  padding-top: 96px;
  padding-left: 31px;
  background: url('~@/assets/images/product/product.png') no-repeat;
  background-size: 100% 100%;
  text-align: left;
}
.content_product{
  margin-top: 100px;
  text-align: center;
  margin-bottom:120px;
  .content_title{
    font-size: 30px;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
    margin-bottom:68px;
  }
  .type_list{
      width:65%;
      margin:auto;
      text-align: center;
      .list_info{
          display:flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          margin-bottom:55px;
          .list_item_product{
              width: 420px;
              height: 150px;
              display:flex;
              justify-content: left;
              align-items: center;
              flex-wrap: wrap !important;
              padding:40px 31px;
              background-color: #ffffff;
              box-shadow: 0px 0px 40px 0px #e4eaef;
              margin-left:41px;
              margin-bottom:51px;
              border-radius: 8px;
              .item_icon{
                  width:74px;
                  height: 74px;
              }
              .item_content{
                  padding-left:50px;
                  display: flex;
                  align-items: flex-start;
                  justify-content: center;
                  flex-direction: column;
                  .item_type_name{
                    font-size: 21px;
                    font-weight: bold;
                    letter-spacing: 0px;
                    color: #333333;
                  }
                  .item_type_descript{
                      padding-top:12px;
                      color: #999999;
                      font-size:18px;
                  }
              }
          }

          .list_item_product_special{
              width:570px !important;
          }
      }
  }

   
      
}

  .buttom_group{
      display: flex;
      align-items: center;
      justify-content: center;
      color:#ffffff;
      .register_info{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 128px;
            height: 44px;
            background-color: #0572cc;
            border-radius: 22px;
            cursor: pointer;
      }
      .learn_more{
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left:10px;
          color:#0572cc;
          width: 128px;
          height: 44px;
          background-color: #ffffff;
          border-radius: 22px;
	      border: solid 1px #0572cc;
          cursor: pointer;
      }
  }
.pc_c_info{

    background: url('~@/assets/images/product/background_pd.png') no-repeat;
    background-size: 100% 100%;

.pc_content{
    
    width:80%;
    margin:auto;
    text-align: center;
    padding-bottom:109px ;
    .pc_title{
        padding-top:82px;        
        padding-bottom:82px;
        color:#333333;
        font-size: 30px;
        font-weight: bold;
    }
    .pc_info_content{
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom:61px ;
        flex-wrap: wrap;
        .image_pc{
            width:700px;
            height: 412px;
            // background-color: #333333;
            border-radius: 10px;
            // display: flex;
            // justify-content: center;
            // align-items: center;
            
            // background: url('~@/assets/images/product/pc_product.png') no-repeat;
            // background-size: 100% 100%;
            img{
                width:100%;
                // height: 100%;
            }
            margin-bottom:50px;
            
        }
        .pc_descript{
            // padding-left:77px;
            padding-left:77px;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            flex-direction: column;

            .pc_item{
                padding-bottom: 25px;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;

                .item_pc_title{
                    font-size:21px;
	                color: #333333;
                }
                .item_pc_content{
                    padding-top:12px;
                    color:#999999;
                    text-align: left;
                    font-size:18px;
                }
            }
        }
    }
}
}
        
</style>




// WEBPACK FOOTER //
// src/view/product/index.vue